const swiperInit = (Swiper) => {
  const elements = document.querySelectorAll("[data-brand-slider-slider]");
  if (elements.length === 0) {
    console.error("No elements found with [data-brand-slider-slider]");
    return;
  }

  elements.forEach((element) => {
    const swiperInstance = new Swiper(element, {
      slidesPerView: 1,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });

    // swiperInstance.on("slideChange", function () {
    //   console.log("Slide changed to: ", this.activeIndex);
    // });
  });
};

if (window.Swiper) {
  /* Don't import Swiper if it's available globally already */
  swiperInit(Swiper);
} else {
  console.log("Adding Swiper!");
  import(
    "https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.4.1/swiper-bundle.esm.browser.js"
  )
    .then((module) => {
      const Swiper = module.default;
      Swiper && swiperInit(Swiper);
    })
    .catch((error) => {
      console.error(`There was an error loading the module: ${error}`);
    });
}